import React from 'react'

import { Label, Notification } from '@pb/components'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import appSelectors from 'App/duck/selectors'
import actions from 'features/Styleboard/styleboard-overview/duck/actions'
import selectors from 'features/Styleboard/styleboard-overview/duck/selectors'
import {
  Notification as NotificationType,
  StyleboardNotificationProps,
} from 'features/Styleboard/types'

import styles from './StyleboardNotification.module.scss'

const StyleboardNotification: React.FC<StyleboardNotificationProps> = ({
  width = 'fitToTabContainer',
  includeNotifications,
}) => {
  const dispatch = useDispatch()
  const notifications = useSelector(selectors.notifications)
  const filteredNotifications = includeNotifications
    ? notifications?.filter((item) => includeNotifications.includes(item.notification))
    : notifications
  const isSmallScreen = useSelector(appSelectors.getIsSmallScreen)

  const handleOnExit = (notification: NotificationType): void => {
    dispatch(actions.removeNotification(notification))
  }

  const isFullWidth = width === 'fullWidth'

  return (
    <>
      {filteredNotifications?.map((item) => (
        <Notification
          key={item.id}
          onExit={() => handleOnExit(item)}
          contentContainerWidth={isSmallScreen ? 'small' : 'large'}
          type={item.type}
          isPortalEnabled={false}
          additionalClass={cn(
            styles.appWrapper,
            isFullWidth ? styles.fullWidth : styles.fitToTabContainer,
          )}
          isNotificationSticky={false}
          isFullwidth={isFullWidth}
        >
          <Label copyKey={item.message} />
        </Notification>
      ))}
    </>
  )
}

export default StyleboardNotification
